export default "__VITE_ASSET__BNqkqG2R__"